import { ToastContext } from '@gen2/contexts/ToastContext';
import { useContext } from 'react';

export const useToast = () => useContext(ToastContext);
